import { Checkbox, Stack, Typography } from "@mui/material";
import React from "react";
import UserHint from "../display/UserHint";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export default function CheckboxForm({
  hasBorder = true,
  label,
  defaulVal,
  hint = null,
  name,
}) {
  const border = hasBorder ? "1px solid gray" : null;
  const { control } = useFormContext();
  const { t } = useTranslation();
  return (
    <Stack
      border={border}
      p={1}
      borderRadius={1}
      width={"100%"}
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        spacing={1}
      >
        <Typography color={"gray"}>{t(label)}</Typography>
        {hint ? <UserHint hint={hint} iconOnly /> : null}
      </Stack>

      <Controller
        name={name}
        control={control}
        defaultValue={defaulVal || false}
        render={({ field }) => {
          return (
            <Checkbox
              checked={field.value}
              onChange={(e) => {
                field.onChange(e.target.checked);
              }}
            />
          );
        }}
      />
    </Stack>
  );
}
